import React, { useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import Constant from "../../Constant";
import Apa1 from "../../Assets/images/apa1.png";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "92%",
  maxWidth: 420,
  bgcolor: "#FFFFFF",
  borderRadius: "20px",
  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
  outline: "none",
  p: "24px",
  maxHeight: "90vh",
  overflowY: "auto",
};

function SummaryModal({
  open,
  handleClose,
  onBack,
  details = {},
  unit = 10,
  onPay,
}) {
  const [agreed, setAgreed] = useState(true);

  const title = details.title || "Lekki Phase 1 Plot";
  const type = details.type || details.propertyType || "Land";
  const pricePerUnit = details.pricePerUnit || details.price || 25000;
  const availableUnits =
    details.unitsLeft !== undefined
      ? details.unitsLeft
      : details.plotsAvailable !== undefined
        ? details.plotsAvailable
        : 33;

  let displayImage = Apa1;
  if (details.image) {
    displayImage = details.image;
  } else if (Array.isArray(details.projectImages) && details.projectImages.length > 0) {
    displayImage = details.projectImages[0]?.imageUrl || details.projectImages[0];
  } else if (Array.isArray(details.imageUrl) && details.imageUrl.length > 0) {
    displayImage = details.imageUrl[0];
  } else if (typeof details.imageUrl === "string" && details.imageUrl) {
    displayImage = details.imageUrl;
  }

  const subtotal = unit * pricePerUnit;
  // Calculate processing fee (matching reference ~0.9% - 1.5% or exactly ₦2,250 for ₦250,000)
  const processingFee = Math.round(subtotal * 0.009) || 2250;
  const grandTotal = subtotal + processingFee;

  const handlePayClick = () => {
    if (agreed && onPay) {
      onPay({ unit, subtotal, processingFee, grandTotal });
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 400,
        sx: { backgroundColor: "rgba(0, 0, 0, 0.6)" },
      }}
    >
      <Fade in={open}>
        <Box sx={modalStyle}>
          {/* Header */}
          <div className="flex items-center justify-between">
            <button
              type="button"
              onClick={onBack || handleClose}
              className="flex items-center gap-2 text-[#1E222B] font-[700] text-[15px] cursor-pointer hover:opacity-80 transition"
            >
              <ArrowBackIcon sx={{ fontSize: 18, color: "#1E222B" }} />
              <span>Back</span>
            </button>

            <button
              type="button"
              onClick={handleClose}
              className="w-9 h-9 rounded-full bg-[#18191B] hover:bg-black text-white flex items-center justify-center cursor-pointer transition shadow-xs"
              aria-label="Close"
            >
              <CloseIcon sx={{ fontSize: 17 }} />
            </button>
          </div>

          {/* Property Banner Card */}
          <div className="bg-white rounded-2xl border border-gray-100 p-3.5 shadow-2xs flex items-center gap-3.5 mt-5">
            <div className="w-[66px] h-[66px] rounded-xl overflow-hidden flex-shrink-0 bg-gray-100">
              <img
                src={displayImage}
                alt={title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-[#1E222B] font-[700] text-[15px] leading-tight truncate">
                {title}
              </h3>
              <p className="text-[#808285] text-[12px] font-[500] mt-0.5">
                ₦{Constant.FormatNumber(pricePerUnit)} per unit
              </p>
              <p className="text-[11px] text-[#808285] font-[600] tracking-wide mt-1">
                AVAILABLE :{" "}
                <span className="font-[800] text-[#1E222B]">
                  {availableUnits} UNITS
                </span>
              </p>
            </div>
            <span className="px-2.5 py-0.5 rounded-[5px] bg-[#65BA00] text-white text-[11px] font-bold uppercase tracking-wide flex-shrink-0">
              {type}
            </span>
          </div>

          {/* Payment Breakdown Card */}
          <div className="bg-white rounded-2xl border border-gray-100 p-4 shadow-2xs mt-4">
            <h4 className="text-[14px] font-[700] text-[#1E222B] mb-3">
              Payment Breakdown
            </h4>

            <div className="space-y-3">
              <div className="flex justify-between items-center text-[12.5px]">
                <span className="text-[#808285] font-[500]">
                  {unit} unit x ₦{Constant.FormatNumber(pricePerUnit)}
                </span>
                <span className="text-[#1E222B] font-[700] text-[13.5px]">
                  ₦{Constant.FormatNumber(subtotal)}
                </span>
              </div>

              <div className="flex justify-between items-center text-[12.5px]">
                {/* <span className="text-[#808285] font-[500]">
                  Processing fee (1.5%0)
                </span>
                <span className="text-[#1E222B] font-[700] text-[13.5px]">
                  ₦{Constant.FormatNumber(processingFee)}
                </span> */}
              </div>

              {/* <div className="border-t border-gray-100 pt-3">
                <span className="text-[#1E222B] font-[700] text-[17px]">
                  ₦{Constant.FormatNumber(grandTotal)}
                </span>
              </div> */}
            </div>
          </div>

          {/* Terms & Conditions Checkbox */}
          <div
            onClick={() => setAgreed(!agreed)}
            className="flex items-start gap-2.5 mt-5 cursor-pointer select-none"
          >
            <div
              className={`w-4 h-4 rounded mt-0.5 flex items-center justify-center transition-colors flex-shrink-0 ${agreed
                ? "bg-[#00BC67] border border-[#00BC67] text-white"
                : "border border-gray-300 bg-white"
                }`}
            >
              {agreed && <CheckIcon sx={{ fontSize: 13, strokeWidth: 2 }} />}
            </div>
            <p className="text-[11px] text-[#808285] leading-tight">
              I agree to the Zouse Investment Terms and understand that real
              estate investments carry risk
            </p>
          </div>

          {/* Pay CTA Button */}
          <button
            type="button"
            onClick={handlePayClick}
            disabled={!agreed}
            className="w-full py-3.5 rounded-xl bg-[#00BC67] hover:bg-[#00a85c] disabled:opacity-50 disabled:cursor-not-allowed text-white font-[700] text-[15px] transition shadow-xs cursor-pointer text-center mt-6"
          >
            Pay
          </button>
        </Box>
      </Fade>
    </Modal>
  );
}

export default SummaryModal;
